import React from 'react';
import withDefaultProps from 'functions/withDefaultProps';

export default function TabButtonHolder(incomingProps) {
	const props = withDefaultProps(incomingProps, defaultProps);
	const { stretch, hideTabs, children, selectedTab, displayChildContent, tabContentClassName, childContentClassName } = props;
	return (
		<React.Fragment>
			{!hideTabs &&
			<div className={`choice_header mobile_view_tabs`}>
				<ul className={`tab_list friend_choices ${stretch ? 'stretch' : ''}`}>
					{children}
				</ul>
			</div>
			}
			{displayChildContent &&
			<div
				className={`tab-content ${tabContentClassName}`}>
				{React.Children.map(children, (child) => {
					if(!child) {
						return null;
					}
					const isSelected = selectedTab === child.props.name || (child.props.contains && child.props.contains[selectedTab]);
					if(!isSelected) {
						return null;
					}
					return (
						<div
							className={`tab-pane ${stretch ? '' : 'normal_width'} ${childContentClassName} active ${child.props.tabPaneClassName ? child.props.tabPaneClassName : ''}`}
							key={child.props.name}
						>
							<div className='tab-pane-content'>
								{child.props.content}
							</div>
						</div>
					);
				})}
			</div>
			}
		</React.Fragment>
	);
}
const defaultProps = {
	stretch: false,
	displayChildContent: false,
	tabContentClassName: '',
};